import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/image/logo.svg';
import MobileMenu from '../MobileMenu/MobileMenu';
import LanguageSwitcher from '../UI/LanguageSwitcher/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

export const navLinks = [
  { path: '/about', display: 'about' },
  { path: '/services', display: 'services' },
  { path: '/cases', display: 'cases' },
];

const Header = ({ color, activeClassName = 'nav__active' }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLanguage, setActiveLanguage] = useState('en');
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const location = useLocation();
  const { t } = useTranslation();
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 8) {
        setIsHeaderVisible(false);
      } else {
        setIsHeaderVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [menuOpen]);

  return (
    <header className={`header ${isHeaderVisible ? 'show' : 'hide'}`}>
      <div className="nav__wrapper">
        <a href="/" className="logo">
          <img src={logo} alt="Logo" />
        </a>
        <div className="navigation">
          <ul className="menu">
            {navLinks.map((item, index) => (
              <li className="nav__item" key={index}>
                <NavLink
                  to={item.path}
                  className={`${
                    location.pathname === item.path ? activeClassName : ''
                  } nav__link`}
                  onClick={(e) => {
                    if (location.pathname === item.path) {
                      e.preventDefault();
                    }
                  }}
                >
                  {t(item.display)}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="header-lang">
            <LanguageSwitcher
              activeLanguage={activeLanguage}
              setActiveLanguage={setActiveLanguage}
            />
          </div>

          <button className="menu-toggle-btn" onClick={toggleMenu}>
            <div className={`burger ${menuOpen ? 'open' : ''}`}>
              <span />
              <span />
            </div>
          </button>

          {menuOpen && (
            <MobileMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
